import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";

/** code generate by generateapi don't edit */
import { getClient } from './internal'; // @cat:
// @name:
// @desc: 获取雷达设置的公众号
// @error:
// @gen_to: setting

/** @type {(r: radar.GetAuthConfigReq, b: any) => Promise<radar.GetAuthConfigRsp>} TypeScript syntax */

export function GetAuthConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/GetAuthConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 设置雷达关联的公众号
// @error:
// @gen_to: setting

/** @type {(r: radar.SetAuthConfigReq, b: any) => Promise<radar.SetAuthConfigRsp>} TypeScript syntax */

export function SetAuthConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/SetAuthConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 创建素材
// @error:
// @gen_to: material

/** @type {(r: radar.AddMaterialReq, b: any) => Promise<radar.AddMaterialRsp>} TypeScript syntax */

export function AddMaterial(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/AddMaterial",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 获取素材详情
// @error:
// @gen_to: material

/** @type {(r: radar.GetMaterialReq, b: any) => Promise<radar.GetMaterialRsp>} TypeScript syntax */

export function GetMaterial(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/GetMaterial",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 修改素材
// @error:
// @gen_to: material

/** @type {(r: radar.SetMaterialReq, b: any) => Promise<radar.SetMaterialRsp>} TypeScript syntax */

export function SetMaterial(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/SetMaterial",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 切换素材状态
// @error:
// @gen_to: material

/** @type {(r: radar.ToggleMaterialStatusReq, b: any) => Promise<radar.ToggleMaterialStatusRsp>} TypeScript syntax */

export function ToggleMaterialStatus(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/ToggleMaterialStatus",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 获取素材列表
// @error:
// @gen_to: material
// @gen: t=get_model_list

/** @type {(r: radar.GetMaterialListReq, b: any) => Promise<radar.GetMaterialListRsp>} TypeScript syntax */

export function GetMaterialList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/GetMaterialList",
    "auth": "1"
  }), o));
}
; // @gen_to: material
// svr options: (ext.UserType) = pub

/** @type {(r: radar.GetMaterialForMpReq, b: any) => Promise<radar.GetMaterialForMpRsp>} TypeScript syntax */

export function GetMaterialForMp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/GetMaterialForMp",
    "auth": "0"
  }), o));
}
; // @gen_to: material
// @gen: t=get_model_list
// svr options: (ext.UserType) = pub

/** @type {(r: radar.GetMaterialListForMpReq, b: any) => Promise<radar.GetMaterialListForMpRsp>} TypeScript syntax */

export function GetMaterialListForMp(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/GetMaterialListForMp",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc: 删除素材
// @error:
// @gen_to: material

/** @type {(r: radar.DelMaterialReq, b: any) => Promise<radar.DelMaterialRsp>} TypeScript syntax */

export function DelMaterial(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/DelMaterial",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 创建分组
// @error:
// @gen_to: category

/** @type {(r: radar.AddCategoryReq, b: any) => Promise<radar.AddCategoryRsp>} TypeScript syntax */

export function AddCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/AddCategory",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 修改分组
// @error:
// @gen_to: category

/** @type {(r: radar.SetCategoryReq, b: any) => Promise<radar.SetCategoryRsp>} TypeScript syntax */

export function SetCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/SetCategory",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 获取分组列表
// @error:
// @gen_to: category

/** @type {(r: radar.GetCategoryListReq, b: any) => Promise<radar.GetCategoryListRsp>} TypeScript syntax */

export function GetCategoryList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/GetCategoryList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 删除分组
// @error:
// @gen_to: category

/** @type {(r: radar.DelCategoryReq, b: any) => Promise<radar.DelCategoryRsp>} TypeScript syntax */

export function DelCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/DelCategory",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 分组排序
// @error:
// @gen_to: category

/** @type {(r: radar.BatchSetCategoryViewOrderReq, b: any) => Promise<radar.BatchSetCategoryViewOrderRsp>} TypeScript syntax */

export function BatchSetCategoryViewOrder(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/BatchSetCategoryViewOrder",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 用户访问记录
// @error:
// @gen_to: visit

/** @type {(r: radar.GetVisitUserListReq, b: any) => Promise<radar.GetVisitUserListRsp>} TypeScript syntax */

export function GetVisitUserList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/GetVisitUserList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:  导出用户访问记录
// @error:
// @gen_to: export

/** @type {(r: radar.ExportVisitUserListReq, b: any) => Promise<radar.ExportVisitUserListRsp>} TypeScript syntax */

export function ExportVisitUserList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/ExportVisitUserList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: h5获取素材信息
// @error:
// @gen_to: material_public
// svr options: (ext.UserType) = pub

/** @type {(r: radar.GetMaterial4PublicReq, b: any) => Promise<radar.GetMaterial4PublicRsp>} TypeScript syntax */

export function GetMaterial4Public(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/GetMaterial4Public",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc: 点击统计
// @error:
// @gen_to: radar_stat

/** @type {(r: radar.GetClickStatReq, b: any) => Promise<radar.GetClickStatRsp>} TypeScript syntax */

export function GetClickStat(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/GetClickStat",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 浏览统计
// @error:
// @gen_to: radar_stat

/** @type {(r: radar.GetViewStatReq, b: any) => Promise<radar.GetViewStatRsp>} TypeScript syntax */

export function GetViewStat(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/GetViewStat",
    "auth": "1"
  }), o));
}
; // @gen_to: event_web

/** @type {(r: radar.GetMaterialRadarEventListReq, b: any) => Promise<radar.GetMaterialRadarEventListRsp>} TypeScript syntax */

export function GetMaterialRadarEventList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/GetMaterialRadarEventList",
    "auth": "1"
  }), o));
}
; // @gen_to: event_web

/** @type {(r: radar.SetMaterialRadarEventListReq, b: any) => Promise<radar.SetMaterialRadarEventListRsp>} TypeScript syntax */

export function SetMaterialRadarEventList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/SetMaterialRadarEventList",
    "auth": "1"
  }), o));
}
; // @desc: 批量设置商品类的素材的事件
// @gen_to: event_product_web

/** @type {(r: radar.BatchSetProductMaterialRadarEventListReq, b: any) => Promise<radar.BatchSetProductMaterialRadarEventListRsp>} TypeScript syntax */

export function BatchSetProductMaterialRadarEventList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/BatchSetProductMaterialRadarEventList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 分享统计
// @error:
// @gen_to: radar_stat

/** @type {(r: radar.GetShareStatReq, b: any) => Promise<radar.GetShareStatRsp>} TypeScript syntax */

export function GetShareStat(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/radar/GetShareStat",
    "auth": "1"
  }), o));
}
;
var RadarServices = {
  GetAuthConfig: GetAuthConfig,
  SetAuthConfig: SetAuthConfig,
  AddMaterial: AddMaterial,
  GetMaterial: GetMaterial,
  SetMaterial: SetMaterial,
  ToggleMaterialStatus: ToggleMaterialStatus,
  GetMaterialList: GetMaterialList,
  GetMaterialForMp: GetMaterialForMp,
  GetMaterialListForMp: GetMaterialListForMp,
  DelMaterial: DelMaterial,
  AddCategory: AddCategory,
  SetCategory: SetCategory,
  GetCategoryList: GetCategoryList,
  DelCategory: DelCategory,
  BatchSetCategoryViewOrder: BatchSetCategoryViewOrder,
  GetVisitUserList: GetVisitUserList,
  ExportVisitUserList: ExportVisitUserList,
  GetMaterial4Public: GetMaterial4Public,
  GetClickStat: GetClickStat,
  GetViewStat: GetViewStat,
  GetMaterialRadarEventList: GetMaterialRadarEventList,
  SetMaterialRadarEventList: SetMaterialRadarEventList,
  BatchSetProductMaterialRadarEventList: BatchSetProductMaterialRadarEventList,
  GetShareStat: GetShareStat
};
export default RadarServices;